import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=2e2ca170&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=ts&"
export * from "./Page.vue?vue&type=script&lang=ts&"
import style0 from "./Page.vue?vue&type=style&index=0&id=2e2ca170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ca170",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopBar: require('/home/circleci/app/components/storyblok/TopBar.vue').default})
